var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.707 6.293C15.7892 6.37825 15.8556 6.47747 15.903 6.586C15.9154 6.61255 15.9239 6.63989 15.9326 6.66801C15.9337 6.67166 15.9349 6.67532 15.936 6.679C15.9649 6.76255 15.9821 6.84972 15.987 6.938C15.9879 6.94813 15.9907 6.95762 15.9935 6.96697C15.9968 6.97792 16 6.98867 16 7V18C16 19.103 15.103 20 14 20H2C0.897 20 0 19.103 0 18V2C0 0.897 0.897 0 2 0H9C9.01149 0 9.02238 0.0032931 9.03333 0.00660326C9.04239 0.00934294 9.05149 0.0120943 9.061 0.013C9.14922 0.0183742 9.23633 0.0355262 9.32 0.0639999C9.32997 0.0674272 9.33994 0.0705632 9.34985 0.0736802C9.37175 0.0805675 9.39335 0.0873619 9.414 0.0969999C9.52253 0.144411 9.62175 0.210782 9.707 0.293L15.707 6.293ZM10 6H12.586L10 3.414V6ZM2 2V18H14.002L14 8H9C8.73478 8 8.48043 7.89464 8.29289 7.70711C8.10536 7.51957 8 7.26522 8 7V2H2ZM12 12V10H4V12H12ZM12 16V14H4V16H12ZM6 6H4V8H6V6Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseIcon);
export default __webpack_public_path__ + "static/media/case_icon.b6f977f415a64bf3faf1c4c586c46dd8.svg";
export { ForwardRef as ReactComponent };